const creditCardManagement = {
  removeCard: 'Entfernen',
};

export default creditCardManagement;
